import { render, staticRenderFns } from "./EntryWall.vue?vue&type=template&id=210ce2cc&scoped=true&"
import script from "@/views/EntryWall/EntryWall.ts?vue&type=script&lang=ts&"
export * from "@/views/EntryWall/EntryWall.ts?vue&type=script&lang=ts&"
import style0 from "@/views/EntryWall/EntryWall.scss?vue&type=style&index=0&id=210ce2cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210ce2cc",
  null
  
)

export default component.exports